import Firebase from 'firebase';
import {firebaseConfig} from "./Constants";

export class FirebaseHelper {
    static getRef() {
        return Firebase.database().ref().child("m3ss4ges")
    }

    static init() {
        Firebase.initializeApp(firebaseConfig);
    }

    static addData = (data, callback) => {
        this.getRef().push(data).then(callback);
    }

    static getOneData = (id, callback) => {
        this.getRef().child(id).once('value').then(callback)
    }

    static getAllData = (callback) => {
        this.getRef().once('value').then(callback)
    }

    static updateOneData = (id, callback) => {
        this.getRef().child(id).child('deleted').set(true).then(callback)
    }

    static deleteOneData = (id, callback) => {
        this.getRef().child(id).remove(callback)
    }

    static deleteAllData = () => {
        this.getRef().remove()
    }
}
